module.exports = __webpack_public_path__ + "static/img/skm2.7e7c17e2.jpg";